<div class="modal-body">
  <div [formGroup]="contactForm" class="form-contact mb">
    @if (activeIndex === 0) {
      <section class="mt-3">
        <div class="row mb-2">
          <div class="col-12">
            <label class="super-compos-label-input">{{ 'editCourrier.personType' | translate }}*</label>
            <p-dropdown
              styleClass="w-100"
              [options]="typeSocieteList"
              [placeholder]="'editCourrier.select' | translate"
              formControlName="typeSociete"
              name="typeSociete"
              (onChange)="switchToCompany()">
            </p-dropdown>
          </div>
        </div>
        @if (!companyMode) {
          <div class="row mb-2">
            <div class="col-4 mb-2">
              <label class="super-compos-label-input">{{ 'editCourrier.firstName' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.firstName' | translate }"
                [type]="'text'"
                [control]="contactForm.get('prenom')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
            <div class="col-4 mb-2">
              <label class="super-compos-label-input">{{ 'editCourrier.lastName' | translate }}*</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.lastName' | translate }"
                [type]="'text'"
                [control]="contactForm.get('nom')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
              @if (f.nom.invalid) {
                <div class="input-error">{{ 'editCourrier.nameRequired' | translate }}</div>
              }
            </div>
            <div class="col-md-4 mb-2">
              <label class="super-compos-label-input">{{ 'editCourrier.email' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.email' | translate }"
                [type]="'text'"
                [control]="contactForm.get('mail')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
          </div>
        }
        @if (!companyMode) {
          <div class="row">
            <div class="col-6 mb-2">
              <label class="super-compos-label-input">{{ 'editCourrier.title' | translate }}</label>
              <p-dropdown
                styleClass="w-100"
                [options]="contactTitles"
                [placeholder]="'editCourrier.select' | translate"
                [showClear]="true"
                formControlName="titre"
                id="titre">
                <ng-template let-item pTemplate="selectedItem"
                  ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
                >
              </p-dropdown>
            </div>
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.language' | translate }}*</label>
              <p-dropdown
                styleClass="w-100"
                [options]="langues"
                [placeholder]="'editCourrier.select' | translate"
                [showClear]="true"
                formControlName="langueId"
                name="langueId">
              </p-dropdown>
              @if (f.langueId.invalid) {
                <div class="input-error">{{ 'editCourrier.languageRequired' | translate }}</div>
              }
            </div>
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.nationalRegistryNumber' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.nationalRegistryNumber' | translate }"
                [type]="'text'"
                [control]="contactForm.get('numeroCarteNISS')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
          </div>
        }
        <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$ Company Mode $$$$$$$$$$$$$$$$$$$$$$$$$ -->
        @if (companyMode) {
          <div>
            <div class="row mb-2">
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.lastName' | translate }}*</label>
                <i-input
                  [iInput]="{ placeholder: 'editCourrier.lastName' | translate }"
                  [type]="'text'"
                  [control]="contactForm.get('nom')"
                  [showError]="false"
                  styleClass="d-block w-100"></i-input>
                @if (f.nom.invalid) {
                  <div class="input-error">{{ 'editCourrier.nameRequired' | translate }}</div>
                }
              </div>
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.businessSector' | translate }}</label>
                <p-autoComplete
                  id="secteurActivite"
                  [dropdown]="true"
                  styleClass="w-100"
                  formControlName="secteurActivite"
                  type="search"
                  #Dropdown
                  styleClass="w-100"
                  [suggestions]="filteredSectors | sort: 'label' : 'ASC'"
                  [placeholder]="'editCourrier.select' | translate"
                  dataKey="value"
                  field="label"
                  (completeMethod)="search($event, 'sector')"
                  (onSelect)="onSelectSector($event)">
                </p-autoComplete>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.TVA' | translate }}</label>
                <div class="d-flex justify-content-between row">
                  <div class="col-md-4">
                    <p-dropdown
                      [options]="codeTvaList | sort: 'label' : 'ASC'"
                      placeholder="Code Pays"
                      [showClear]="false"
                      formControlName="tvaPrefix"
                      (onChange)="onTvaCodeChg($event.value)"
                      name="tvaPrefix"
                      autocomplete="BE"
                      styleClass="w-100">
                    </p-dropdown>
                  </div>
                  <div class="col-md-8">
                    @if (!tvaFrMode) {
                      <p-inputMask
                        formControlName="tva"
                        [mask]="tvaMask"
                        appendTo="body"
                        [characterPattern]="tvaRegex"
                        styleClass="super-compos-input-text form-control w-100"
                        [placeholder]="tvaPlaceholder"
                        name="tva"
                        tooltipZIndex="99999999"
                        tooltipPosition="top"
                        [autoClear]="false">
                      </p-inputMask>
                    }
                    @if (tvaFrMode) {
                      <p-inputMask
                        formControlName="tva"
                        mask="FR-**999999999"
                        styleClass="super-compos-input-text form-control w-100"
                        placeholder="FR-**999999999"
                        name="tva"
                        pTooltip="Code pays + 11 chiffres (le premier et le deuxième caractère peut être une lettre)."
                        tooltipZIndex="99999999"
                        tooltipPosition="top"
                        [autoClear]="false">
                      </p-inputMask>
                    }
                    @if (f.tva.invalid) {
                      <div class="input-error" placeholder="TVA">La TVA est requise</div>
                    }
                  </div>
                </div>
              </div>
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.legalForm' | translate }}</label>
                <p-dropdown
                  styleClass="w-100"
                  [options]="legalForms | sort: 'label' : 'ASC'"
                  [placeholder]="'editCourrier.select' | translate"
                  [showClear]="true"
                  formControlName="societeFormeJuridiqueId"
                  id="societeFormeJuridiqueId"></p-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.BCE' | translate }} </label>
                @if (codePays === 'BE') {
                  <p-inputMask
                    formControlName="bce"
                    [mask]="bceMask"
                    styleClass="super-compos-input-text form-control w-100"
                    [placeholder]="bcePlaceholder"
                    [title]="bceTooltip"
                    name="bce">
                  </p-inputMask>
                }
                @if (codePays !== 'BE') {
                  <i-input
                    [iInput]="{ placeholder: 'Bce' }"
                    [type]="'text'"
                    [control]="contactForm.get('bce')"
                    [showError]="false"
                    styleClass="d-block w-100"></i-input>
                }
              </div>
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.language' | translate }}*</label>
                <p-dropdown
                  styleClass="w-100"
                  [options]="langues | sort: 'label' : 'ASC'"
                  placeholder="Sélectionnez une langue"
                  [showClear]="true"
                  formControlName="langueId"
                  name="languId">
                </p-dropdown>
                @if (f.langueId.invalid) {
                  <div class="input-error">{{ 'editCourrier.languageRequired' | translate }}</div>
                }
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <label class="super-compos-label-input"> {{ 'editCourrier.manager' | translate }}</label>
                <i-input
                  [iInput]="{ placeholder: 'Nom + prénom' }"
                  [type]="'text'"
                  [control]="contactForm.get('gerantSociete')"
                  [showError]="false"
                  styleClass="d-block w-100"></i-input>
              </div>
              <div class="col-md-6 mb-2">
                <label class="super-compos-label-input">{{ 'editCourrier.email' | translate }}</label>
                <i-input
                  [iInput]="{ placeholder: 'editCourrier.email' | translate }"
                  [type]="'text'"
                  [control]="contactForm.get('mail')"
                  [showError]="false"
                  styleClass="d-block w-100"></i-input>
              </div>
            </div>
          </div>
        }
        <div class="form__part2 mb-4">
          <h3 class="super-compos-titre-h3 mt-3">{{ 'editCourrier.contactOptions' | translate }}</h3>
          <div class="row mb-2">
            <div class="col-6">
              <label class="super-compos-label-input"
                >{{ 'editCourrier.contactType' | translate }}
                @if (connectedContactAccessContacts) {
                  <i (click)="openNewTypeContact()" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                }
              </label>
              <p-dropdown
                styleClass="w-100"
                [filter]="true"
                [options]="typeContacts | sort: 'label' : 'ASC'"
                appendTo="body"
                [placeholder]="'editCourrier.select' | translate"
                [showClear]="true"
                formControlName="typeContactId"
                id="typeContactId"></p-dropdown>
            </div>
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.internalName' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.internalName' | translate }"
                [type]="'text'"
                [control]="contactForm.get('nomInterne')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
          </div>
        </div>
        <div class="form__part4 mb-3">
          <div class="row mb-3">
            <div class="col-md-12 d-flex align-items-center justify-content-between">
              <h3 class="super-compos-titre-h3 mt-3">{{ 'editCourrier.addresses' | translate }}</h3>
              <i-button [text]="'editCourrier.addAddress' | translate" styleClass="green" size="small" (click)="add()" id="addAddress"></i-button>
            </div>
            <div class="col-md-12 mt-2">
              @if (getAdressPrincipal.controls.length === 0) {
                <div class="alert alert-warning" role="alert">{{ 'editCourrier.noAddressEncoded' | translate }}</div>
              }
            </div>
          </div>
          <div class="form__part4__primary">
            @for (item of getAdressPrincipal.controls; track item; let i = $index) {
              <div formArrayName="listContactsAdresses">
                <form class="row mb-2 align-content-center" autocomplete="new-password" [formGroupName]="i">
                  <div class="col-md-12 row pe-0 me-0">
                    <div class="col-12 mb-2 pe-0">
                      <label class="super-compos-label-input d-block">{{ 'editCourrier.addressType' | translate }} *</label>
                      <p-dropdown
                        styleClass="w-100"
                        [options]="typesAdresses"
                        [placeholder]="'editCourrier.select' | translate"
                        [showClear]="true"
                        appendTo="body"
                        formControlName="type"
                        id="typeAdd{{ i }}"
                        [disabled]="
                          item.get('type').value === 'PRINCIPALE' || item.get('type').value === 'SECONDAIRE' || item.get('type').value === 'PRIVE'
                        "></p-dropdown>
                    </div>
                    <div class="col-md-12 mt-3 mb-2">
                      <h3 class="contact__subtitle">{{ 'editCourrier.structuredAddress' | translate }}</h3>
                    </div>
                    <div class="col-md-3 mb-2 p-fluid">
                      <label class="super-compos-label-input">{{ 'editCourrier.addressCountry' | translate }}</label>
                      <p-dropdown
                        optionLabel="description"
                        optionValue="id"
                        [filter]="true"
                        styleClass="w-100"
                        [options]="countriesList"
                        [placeholder]="'contact.selectCountry' | translate"
                        [showClear]="true"
                        appendTo="body"
                        formControlName="pays"
                        (onChange)="clearZIPAndStreet(i); selectCountry($event)"></p-dropdown>
                    </div>
                    <div class="col-md-3 mb-2 p-fluid input-api">
                      <label class="super-compos-label-input"
                        >{{ 'editCourrier.addressPostalCode' | translate }} - {{ 'editCourrier.addressLocality' | translate }}
                        @if (connectedContactAccessContacts) {
                          <i (click)="openNewPostalCodeModal(i, 'structure')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                        }
                      </label>
                      <p-autoComplete
                        (onBlur)="leaveInput('cp', i)"
                        id="dropdownCPLocaliteNotFranceContact{{ i }}"
                        minlength="2"
                        baseZIndex="10"
                        type="search"
                        #Dropdown
                        (onFocus)="focusAutoComplete()"
                        formControlName="structure_LocaliteId"
                        name="structure_LocaliteId"
                        appendTo="body"
                        [suggestions]="filteredPostalCodes"
                        styleClass="w-100"
                        (completeMethod)="search($event, 'postalCode', i)"
                        [showTransitionOptions]="'0ms'"
                        [hideTransitionOptions]="'0ms'"
                        field="autoCompleteField"
                        dataKey="id"
                        placeholder="Code postal - Localité"
                        (onSelect)="selectPostalCode($event, i)"
                        (onClear)="clearStreet(i)">
                      </p-autoComplete>
                    </div>
                    <div class="col-md-3 mb-2 p-fluid">
                      <label class="super-compos-label-input"
                        >{{ 'editCourrier.addressStreet' | translate }}
                        @if (connectedContactAccessContacts) {
                          <i (click)="openNewStreetModal(i, 'structure')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                        }
                      </label>
                      <p-autoComplete
                        (onBlur)="leaveInput('street', i)"
                        id="autocompleteRueContact{{ i }}"
                        minLength="3"
                        #DropdownRue
                        type="search"
                        (onFocus)="focusAutoComplete()"
                        formControlName="structure_RueId"
                        [suggestions]="filteredStreets"
                        styleClass="w-100"
                        (completeMethod)="search($event, 'street', i)"
                        field="rueNom"
                        dataKey="id"
                        [placeholder]="'editCourrier.addressStreet' | translate"
                        (onSelect)="selectStreet($event, i)"
                        name="structure_RueId"></p-autoComplete>
                    </div>
                    <div class="col-md-2 mb-2 p-fluid">
                      <label class="super-compos-label-input">{{ 'editCourrier.number' | translate }}</label>
                      <input
                        id="inputNumeroContact{{ i }}"
                        formControlName="structure_RueNumero"
                        autocomplete="new-password"
                        type="search"
                        class="super-compos-input-text form-control w-100"
                        placeholder="Numéro" />
                    </div>
                    <div class="col-md-1 mb-2 pe-0 p-fluid">
                      <label class="super-compos-label-input">{{ 'editCourrier.box' | translate }}</label>
                      <input
                        formControlName="structure_RueBoite"
                        type="search"
                        autocomplete="new-password"
                        class="super-compos-input-text form-control w-100"
                        placeholder="Boite" />
                    </div>
                    <div class="col-md-12 mt-2 pe-0 mb-2 d-flex align-items-center">
                      <i-button
                        id="impressionAddressContactButton"
                        text="{{ !listOfDisplayedImpressionAdresses[i] ? 'Afficher' : 'Masquer' }} l'adresse d'impression"
                        styleClass="blue"
                        size="small"
                        (click)="listOfDisplayedImpressionAdresses[i] = !listOfDisplayedImpressionAdresses[i]"></i-button>
                      @if (listOfDisplayedImpressionAdresses[i] === true) {
                        <i-button
                          id="copyImpressionAddressContactButton"
                          pTooltip="Convertir l'adresse structuré en impression"
                          tooltipPositon="bottom"
                          text="Générer l'adresse d'impression"
                          styleClass="blue ms-3"
                          size="small"
                          (click)="convertImpression(i)"></i-button>
                      }
                    </div>
                    @if (listOfDisplayedImpressionAdresses[i] === true) {
                      <div class="col-md-12 mt-3 mb-2">
                        <h3 class="contact__subtitle" pTooltip="Adresse qui sera imprimée sur les courriers générés" tooltipPosition="bottom">
                          {{ 'editCourrier.printAddress' | translate }}
                        </h3>
                      </div>
                    }
                    @if (listOfDisplayedImpressionAdresses[i] === true) {
                      <div class="col-md-3 mb-2">
                        <label class="super-compos-label-input">Pays</label>
                        <input
                          type="search"
                          id="impressionPaysContactInput"
                          pInputText
                          autocomplete="new-password"
                          formControlName="impression_Pays"
                          class="super-compos-input-text form-control w-100"
                          [placeholder]="'editCourrier.addressCountry' | translate" />
                      </div>
                    }
                    @if (listOfDisplayedImpressionAdresses[i] === true) {
                      <div class="col-md-3 mb-2">
                        <label class="super-compos-label-input"
                          >{{ 'editCourrier.addressPostalCode' | translate }}
                          @if (connectedContactAccessContacts) {
                            <i (click)="openNewPostalCodeModal(i, 'impression')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                          }
                        </label>
                        <input
                          type="search"
                          id="impressionCodePostalContactInput"
                          pInputText
                          autocomplete="new-password"
                          formControlName="impression_CodePostal"
                          class="super-compos-input-text form-control w-100"
                          [placeholder]="'editCourrier.addressPostalCode' | translate" />
                      </div>
                    }
                    @if (listOfDisplayedImpressionAdresses[i] === true) {
                      <div class="col-md-3 mb-2">
                        <label class="super-compos-label-input"
                          >{{ 'editCourrier.addressLocality' | translate }}
                          @if (connectedContactAccessContacts) {
                            <i (click)="openNewPostalCodeModal(i, 'impression')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                          }
                        </label>
                        <input
                          type="search"
                          id="impressionLocaliteContactInput"
                          pInputText
                          autocomplete="new-password"
                          formControlName="impression_Localite"
                          class="super-compos-input-text form-control w-100"
                          placeholder="Localité" />
                      </div>
                    }
                    @if (listOfDisplayedImpressionAdresses[i] === true) {
                      <div class="col-md-3 mb-2">
                        <label class="super-compos-label-input"
                          >{{ 'editCourrier.addressStreet' | translate }}
                          @if (connectedContactAccessContacts) {
                            <i (click)="openNewStreetModal(i, 'impression')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                          }
                        </label>
                        <textarea
                          id="impressionRueContactTextarea"
                          pInputText
                          autocomplete="new-password"
                          formControlName="impression_Adresse"
                          class="super-compos-input-text form-control w-100"
                          [placeholder]="'editCourrier.addressStreet' | translate"></textarea>
                      </div>
                    }
                    <div class="col-md-12 mt-3 mb-2">
                      <h3 class="contact__subtitle">{{ 'editCourrier.information' | translate }}</h3>
                    </div>
                    <div class="col-2 mb-2 ui-group">
                      <label class="super-compos-label-input d-block">{{ 'editCourrier.countryCode' | translate }}</label>
                      <p-dropdown
                        baseZIndex="1000"
                        [showClear]="true"
                        [options]="codeTvaList | sort: 'label' : 'ASC'"
                        placeholder="Code Pays"
                        styleClass="w-20"
                        [showClear]="false"
                        appendTo="body"
                        (onChange)="onCountryChange($event.value)"
                        autocomplete="BE"
                        styleClass="w-100">
                        <ng-template let-country pTemplate="selectedItem">
                          @if (country.label !== 'AUTRE') {
                            <img src="./assets/img/Flags/{{ country?.label }}.svg" width="25" height="25" class="img-fluid me-2" alt="" />
                          }
                          <span class="ms-2">{{ country?.label }}</span>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                          <div class="ui-helper-clearfix" style="position: relative; height: 25px">
                            @if (country.label !== 'AUTRE') {
                              <img src="./assets/img/Flags/{{ country?.label }}.svg" width="25" height="25" class="img-fluid me-2" alt="" />
                            }
                            <span class="ms-2">{{ country?.label }}</span>
                          </div>
                        </ng-template>
                      </p-dropdown>
                    </div>
                    <div class="col-3 mb-2">
                      <label class="super-compos-label-input d-block">{{ clientType === 'JVS' ? 'Tel. portable' : 'GSM' }}</label>
                      @if (prefixNumber) {
                        <p-inputMask
                          appendTo="body"
                          styleClass="w-100 form-control"
                          formControlName="gsm"
                          name="gsm"
                          mask="{{ prefixNumber }} 999 99 99 99"></p-inputMask>
                      }
                      @if (!prefixNumber) {
                        <input
                          type="number"
                          formControlName="gsm"
                          autocomplete="new-password"
                          class="noArrow super-compos-input-text form-control w-100"
                          name="gsm" />
                      }
                    </div>
                    <div class="col-3 mb-2">
                      <label class="super-compos-label-input">{{ 'editCourrier.telephone' | translate }}</label>
                      <input
                        type="text"
                        formControlName="telephone"
                        class="super-compos-input-text form-control w-100"
                        name="telephone"
                        autocomplete="new-password" />
                    </div>
                    @if (i !== 0) {
                      <div class="col-md-4 mb-2">
                        <label class="super-compos-label-input">{{ 'editCourrier.email' | translate }}</label>
                        <input
                          (input)="checkEmailPattern(i)"
                          formControlName="mail"
                          autocomplete="new-password"
                          class="super-compos-input-text form-control w-100"
                          [placeholder]="'editCourrier.email' | translate"
                          name="mail" />
                        @if (!checkEmailPattern(i)) {
                          <div class="input-error">{{ 'editCourrier.incorrectAddressFormat' | translate }}</div>
                        }
                      </div>
                    }
                    <div class="col-6 mb-2">
                      <label class="super-compos-label-input">{{ 'editCourrier.fax' | translate }}</label>
                      <input
                        formControlName="fax"
                        autocomplete="new-password"
                        type="phone"
                        class="super-compos-input-text form-control w-100"
                        [placeholder]="'editCourrier.fax' | translate"
                        name="fax" />
                    </div>
                    <div class="col-6 mb-2">
                      <label class="super-compos-label-input">{{ 'editCourrier.website' | translate }}</label>
                      <input
                        formControlName="site"
                        autocomplete="new-password"
                        type="text"
                        class="super-compos-input-text form-control w-100"
                        [placeholder]="'editCourrier.website' | translate"
                        name="site" />
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-4">
                    <i-button text="Supprimer l'adresse" styleClass="red d-inline-block" size="small" class="d-inline-block" (click)="remove(i)"
                      >delete</i-button
                    >
                  </div>
                </form>
              </div>
            }
          </div>
        </div>
        <!--  $$$ End Adress switch $$$ -->
        <!-- $$$$$$ShowMore$$$$$$$$$$$$ -->
        <div class="form__showMore">
          <div class="d-flex justify-content-center">
            @if (!fullMode) {
              <i-button text="Afficher les informations supplémentaires" (click)="showMore()" styleClass="blue showMoreBtn mb-5" icon="bi bi-zoom-in">
              </i-button>
            }
            @if (fullMode) {
              <i-button text="Cacher les informations supplémentaires" (click)="showMore()" styleClass="blue showMoreBtn mb-5" icon="bi bi-zoom-out">
              </i-button>
            }
          </div>
          @if (fullMode) {
            <div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <h3 class="super-compos-titre-h3 mt-3">{{ 'editCourrier.additionalInfo' | translate }}</h3>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label class="super-compos-label-input">{{ 'editCourrier.website' | translate }}</label>
                  <i-input
                    [iInput]="{ placeholder: 'editCourrier.website' | translate }"
                    [type]="'text'"
                    [control]="contactForm.get('siteWeb')"
                    [showError]="false"
                    styleClass="d-block w-100"></i-input>
                </div>
              </div>
              @if (!companyMode) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.birthdate' | translate }}</label>
                    @if (locale4Calendar) {
                      <p-calendar
                        [defaultDate]="datebirthdefault"
                        [locale]="locale4Calendar"
                        [firstDayOfWeek]="1"
                        appendTo="body"
                        formControlName="dateNaissance"
                        [showIcon]="true"
                        [iconDisplay]="'input'"
                        dateFormat="dd/mm/yy"
                        [placeholder]="'editCourrier.birthdate' | translate"
                        [yearRange]="yearRange">
                      </p-calendar>
                    }
                  </div>
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.birthplace' | translate }}</label>
                    <i-input
                      [iInput]="{ placeholder: 'editCourrier.birthplace' | translate }"
                      [type]="'text'"
                      [control]="contactForm.get('naissanceLieu')"
                      [showError]="false"
                      styleClass="d-block w-100"></i-input>
                  </div>
                </div>
              }
              @if (!companyMode) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.maritalStatus' | translate }}</label>
                    <p-dropdown
                      styleClass="w-100"
                      [options]="etatCivils | sort: 'label' : 'ASC'"
                      [placeholder]="'editCourrier.select' | translate"
                      [showClear]="true"
                      formControlName="etatCivil"
                      name="etatCivil"></p-dropdown>
                  </div>
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.gender' | translate }}</label>
                    <p-dropdown
                      styleClass="w-100"
                      [options]="sexes | sort: 'label' : 'ASC'"
                      [placeholder]="'editCourrier.select' | translate"
                      [showClear]="true"
                      formControlName="sexe"
                      name="sexe">
                    </p-dropdown>
                  </div>
                </div>
              }
              @if (!companyMode) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.nationality' | translate }}</label>
                    <p-dropdown
                      styleClass="w-100"
                      [options]="nationalites | sort: 'label' : 'ASC'"
                      [placeholder]="'editCourrier.select' | translate"
                      [showClear]="true"
                      formControlName="nationalite"
                      name="nationalite"></p-dropdown>
                  </div>
                </div>
              }
              <div class="row mb-2">
                <div class="col-12">
                  <label class="super-compos-label-input">{{ 'editCourrier.remarks' | translate }}</label>
                  <textarea id="float" class="w-100" pInputTextarea [rows]="3" formControlName="commentaires" name="commentaires"></textarea>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    }
  </div>
  <p-confirmDialog
    #cd
    appendTo="body"
    key="Close"
    styleClass="super-compos-modal-content confirmModal"
    header="Confirmation"
    icon="bi bi-exclamation-triangle"
    baseZIndex="99999">
    <p-footer>
      <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
      <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
  <p-confirmDialog
    #xd
    appendTo="body"
    key="Address"
    styleClass="super-compos-modal-content confirmModal"
    header="Confirmation"
    icon="bi bi-exclamation-triangle"
    baseZIndex="99999">
    <p-footer>
      <button type="button" pButton icon="pi pi-times" label="Non" (click)="xd.reject()"></button>
      <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="xd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
</div>

<p-confirmDialog
  key="contact"
  baseZIndex="999999"
  #dd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  header="Confirmation"
  icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="dd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="dd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showCreateCP" [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">Gestion d'un code postal</h5>
      <div class="d-flex">
        <i-button styleClass="blue" (click)="showCreateCP = false" text="Annuler"></i-button>
        <i-button styleClass="green ms-3" [disabled]="!formCP.valid" (click)="submitNewCP()" text="Confirmer"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formCP" class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Pays</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="countries"
        [filter]="true"
        placeholder="Sélectionnez un pays"
        [showClear]="true"
        formControlName="paysID">
      </p-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Code Postal *</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 4000' }"
        [type]="'text'"
        [control]="formCP.get('codePostal')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Localité</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 1' }"
        [type]="'text'"
        [control]="formCP.get('localite')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Langue</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="langues"
        [filter]="true"
        placeholder="Sélectionnez une langue"
        [showClear]="true"
        formControlName="langueID">
      </p-dropdown>
    </div>
  </form>
</p-dialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showCreateStreet" [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">Gestion d'une rue</h5>
      <div class="d-flex">
        <i-button styleClass="blue" (click)="showCreateStreet = false" text="Annuler"></i-button>
        <i-button styleClass="green ms-3" [disabled]="!formStreet.valid" (click)="submitNewStreet()" text="Confirmer"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formStreet" class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Rue</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: Rue des belles vignes' }"
        [type]="'text'"
        [control]="formStreet.get('rue')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Code Postal *</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 4000' }"
        [type]="'text'"
        [control]="formStreet.get('codePostal')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Code rue</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 1' }"
        [type]="'text'"
        [control]="formStreet.get('codeRue')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Code langue</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: FR' }"
        [type]="'text'"
        [control]="formStreet.get('codeLangue')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
  </form>
</p-dialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showCreateContactType" [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">Gestion d'un type de contact</h5>
      <div class="d-flex">
        <i-button styleClass="blue me-3" text="Annuler" (click)="showCreateContactType = false"></i-button>
        <i-button styleClass="green" (click)="submitNewContactType()" text="Confirmer"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formContactType" class="mt-3 row">
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input"> Verrouillé </label>
      <p-inputSwitch formControlName="verrouille"></p-inputSwitch>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Description *</label>
      <i-input
        [iInput]="{ placeholder: 'editCourrier.descriptionContact' | translate }"
        [type]="'text'"
        [control]="formContactType.get('typeContact')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Ordre de tri</label>
      <i-input
        [iInput]="{ placeholder: 'editCourrier.descriptionOrder' | translate }"
        [type]="'text'"
        [control]="formContactType.get('ordreTri')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Filtrer les contacts par type</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="typesLV | sort: 'label' : 'ASC'"
        [filter]="true"
        placeholder="Sélectionnez un type de contact"
        [showClear]="true"
        (onChange)="filterContact($event)">
      </p-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">Type lié à</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="contactsLinked"
        [filter]="true"
        placeholder="Sélectionnez un contact"
        [showClear]="true"
        formControlName="carnetContactID">
      </p-dropdown>
    </div>
    <!-- <div class="col-md-6 mb-3">
                                                      <label class="super-compos-label-input">Création autorisée par</label>
                                                      <p-dropdown
                                                        styleClass="w-100"
                                                        [virtualScroll]="true"
                                                        virtualScrollItemSize="30"
                                                        appendTo="body"
                                                        [options]="groups | sort: 'label' : 'ASC'"
                                                        [filter]="true"
                                                        placeholder="Sélectionnez un groupe"
                                                        [showClear]="true"
                                                        formControlName="creationGereeParGroupeID">
                                                      </p-dropdown>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                      <label class="super-compos-label-input">Modification autorisée par</label>
                                                      <p-dropdown
                                                        styleClass="w-100"
                                                        [virtualScroll]="true"
                                                        virtualScrollItemSize="30"
                                                        appendTo="body"
                                                        [options]="groups | sort: 'label' : 'ASC'"
                                                        [filter]="true"
                                                        placeholder="Sélectionnez un groupe"
                                                        [showClear]="true"
                                                        formControlName="modificationGereeParGroupeId">
                                                      </p-dropdown>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                      <label class="super-compos-label-input">Suppression autorisée par</label>
                                                      <p-dropdown
                                                        styleClass="w-100"
                                                        [virtualScroll]="true"
                                                        virtualScrollItemSize="30"
                                                        appendTo="body"
                                                        [options]="groups | sort: 'label' : 'ASC'"
                                                        [filter]="true"
                                                        placeholder="Sélectionnez un groupe"
                                                        [showClear]="true"
                                                        formControlName="suppressionGereeParGroupeId">
                                                      </p-dropdown>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                      <label class="super-compos-label-input">Visualisation autorisée par</label>
                                                      <p-dropdown
                                                        styleClass="w-100"
                                                        [virtualScroll]="true"
                                                        virtualScrollItemSize="30"
                                                        appendTo="body"
                                                        [options]="groups | sort: 'label' : 'ASC'"
                                                        [filter]="true"
                                                        placeholder="Sélectionnez un groupe"
                                                        [showClear]="true"
                                                        formControlName="visualisationGereeParGroupeID">
                                                      </p-dropdown>
                                                    </div> -->
  </form>
</p-dialog>
